import Link from "../../components/Link";
import React from "react";
import makeid from "../../utils/makeid";
import mergeFilter from "../../components/tree/mergeFilter";
import parseRoute from "../../components/tree/parseRoute";
import { withTranslate } from "react-admin";

const TreeLinkField = ({
  record,
  source,
  children,
  dispatch,
  basePath,
  translate,
}) => {
  const { filter } = parseRoute();
  if (record?.type === "floor") {
    return React.Children.map(children, (child) =>
      React.cloneElement(child, {
        record,
        source,
        dispatch,
      })
    );
  }

  const href = `#${basePath}?filter=${JSON.stringify(
    mergeFilter({
      location_id: record.id,
      expanded: (filter.expanded || []).concat(record.id),
      reload: makeid(8),
    })
  )}`;

  const ModeOpenTabsOn = localStorage.getItem("ModeOpenTabsOn");

  // Gestione del click per aprire in una nuova scheda
  const handleClick = (e) => {
    if (ModeOpenTabsOn !== "true") return;

    e.preventDefault();

    let raw = localStorage.getItem("openEditTabs");
    let openTabs;

    try {
      openTabs = raw ? JSON.parse(raw) : {};
    } catch {
      openTabs = {};
    }

    // Usa la chiave "locationList" per i tab aperti da click sul nome
    const resource = "locationList";

    if (!Array.isArray(openTabs[resource])) {
      openTabs[resource] = [];
    }

    const id = record.id.toString();
    if (openTabs[resource].includes(id)) {
      alert(
        translate("resource.open.tabs.message.block", {
          resource: resource,
          id: id,
        })
      );
      return;
    }

    openTabs[resource].push(id);
    localStorage.setItem("openEditTabs", JSON.stringify(openTabs));

    // Comunica agli altri tab
    const bc = new BroadcastChannel("editTabs");
    bc.postMessage(openTabs);
    bc.close();

    window.open(href, "_blank", "noopener,noreferrer");
  };

  return (
    <Link variant="body1" href={href} onClick={handleClick}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          record,
          source,
          dispatch,
        })
      )}
    </Link>
  );
};

export default withTranslate(TreeLinkField);
